export default "__VITE_ASSET__D17rSYtv__"